import React from 'react';
import { Link } from '@flightstats/airframe-react';
import styled from 'styled-components';

const RowReverseLinkWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  min-width: 40%;
  position: relative;
  top: -35px;
`;

const OrangeLink = styled(Link)`
  position: absolute;
  top: 0px;
  margin-right: 15px;
  color: #faa718;
  :hover {
    color: #faa718;
  }
`;

interface OrangeLinkHeaderProps {
  path: string;
  text: string;
}

export const OrangeLinkHeader: React.FC<OrangeLinkHeaderProps> = ({ path, text }) => {
  return (
    <RowReverseLinkWrapper>
      <OrangeLink href={path}>{text}</OrangeLink>
    </RowReverseLinkWrapper>
  );
};
